<template>
	<div id="app" class="site container hfeed gb-guide-root" style="height: auto !important;">
		<HeadNav selectedLanguage="en" :page="navPage" />
		<div id="content" class="main-wrapper" style="height: auto !important;">
			<div class="markdown-content">
				<slot />
				<RelatedArticles />
			</div>
		</div>
	</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import '@/css/blog/guideMarkdown.scss';
import HeadNav from '@/components/HeadNav.vue';
import RelatedArticles from '@/components/RelatedArticles.vue';

export default {
	name: 'GbGuideArticle',
	components: { HeadNav, RelatedArticles },
	props: {
		// 顶部导航传给 HeadNav（文章类统一 blogs，避免误入 download 路由名）
		navPage: {
			type: String,
			default: 'blogs',
		},
	},
};
</script>
